import consumer from "./consumer"

export function subscribeToConductorChat(threadId, callbacks = {}) {
  const subscription = consumer.subscriptions.create(
    {
      channel: "ConductorChatChannel",
      thread_id: threadId
    },
    {
      initialized() {},

      connected() {
        if (callbacks?.connected) callbacks.connected();
      },

      disconnected() {
        if (callbacks?.disconnected) callbacks.disconnected();
      },

      rejected() {
        if (callbacks?.rejected) callbacks.rejected();
      },

      received: function(data) {
        if (!callbacks) return;

        // Handle different message types
        switch (data.type) {
          case 'chunk':
            if (callbacks.onChunk) callbacks.onChunk(data.content, data.message_id);
            break;
          case 'complete':
            if (callbacks.onComplete) callbacks.onComplete(data.message, data.context_usage);
            break;
          case 'error':
            if (callbacks.onError) callbacks.onError(data);
            break;
          case 'tool_started':
            if (callbacks.onToolStarted) callbacks.onToolStarted(data);
            break;
          case 'tool_completed':
            if (callbacks.onToolCompleted) callbacks.onToolCompleted(data);
            break;
          case 'processing_started':
            if (callbacks.onProcessingStarted) callbacks.onProcessingStarted(data);
            break;
          case 'processing_classified':
            if (callbacks.onProcessingClassified) callbacks.onProcessingClassified(data);
            break;
          case 'processing_complete':
            if (callbacks.onProcessingComplete) callbacks.onProcessingComplete(data);
            break;
          case 'processing_failed':
            if (callbacks.onProcessingFailed) callbacks.onProcessingFailed(data);
            break;
          default:
            if (callbacks.received) callbacks.received(data);
        }
      }
    }
  );

  return subscription;
}
